/* eslint-disable @angular-eslint/component-selector */
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component, Input, Output, EventEmitter, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ComboBoxComponent, KENDO_COMBOBOX } from '@progress/kendo-angular-dropdowns';
import { KENDO_LABEL, KENDO_FLOATINGLABEL } from '@progress/kendo-angular-label';
import { KENDO_CHECKBOX, KENDO_TEXTBOX } from '@progress/kendo-angular-inputs';

import { toSignal } from '@angular/core/rxjs-interop';
import { ISeaport } from '../models';

import { SeaportPickerEntityStore } from './seaport-picker.store';
import { SeaportPickerService } from './seaport-picker.service';

@Component({
  selector: 'pmis3-seaport-picker',
  standalone: true,
  imports: [CommonModule, FormsModule, KENDO_COMBOBOX, KENDO_LABEL, KENDO_FLOATINGLABEL, KENDO_CHECKBOX, KENDO_TEXTBOX],
  templateUrl: './seaport-picker.component.html',
  providers: [SeaportPickerEntityStore, SeaportPickerService]
})
export class SeaportPickerComponent implements OnChanges {
  @Input() value: number | undefined = undefined;
  @Output() valueChange = new EventEmitter<number>();

  @Input() isValid: boolean = true;
  @Input() isRequired: boolean = false;
  @Input() disabled: boolean = false;
  @Input() placeholder: string = 'Type to search for a port';
  @Input() seaPortPickerTitle: string = '';

  // NEW: accept the data directly from parent (web component or page)
  @Input() seaports: ISeaport[] = [];

  @ViewChild('seaPortPicker') seaPortPicker!: ComboBoxComponent;

  // Signals from store
  seaports$   = toSignal(this.store.visibleSeaports$, { initialValue: [] as ISeaport[] });
  loading$    = toSignal(this.store.loading$, { initialValue: false });
  filterText$ = toSignal(this.store.filter$,   { initialValue: '' });

  // Keep for the "no data" template messaging
  searchText: string = '';

  constructor(private store: SeaportPickerEntityStore) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['seaports']) {
      this.store.setSeaports(this.seaports ?? []);
      this.store.syncTextFromSelection();
    }
    if (changes['value']) {
      this.store.setSelectedId(this.value);
      this.store.syncTextFromSelection();
    }
  }

  onFilterChange(filter: string) {
    this.searchText = filter ?? '';
    this.store.setFilter(this.searchText);
  }

  onValueChange(event: number) {
    this.store.setSelectedId(event);
    this.valueChange.emit(event);
  }
}
